import { Component, OnInit } from '@angular/core';
import { PackageReceiveService } from '../../data-services/package.receive.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
   selector: 'package-receive-progress',
   templateUrl: './package.receive.progress.html',
   styleUrls: ['./step.css'],
   providers: [MessageService],
   imports: [CommonModule]
})
export class PackageReceiveProgressComponent implements OnInit {

   package: PackageReceiveService;
   showSpinner: boolean = false;

   constructor(private packageReceiveSvc: PackageReceiveService,
      private router: Router) {
      this.package = packageReceiveSvc;
   }

   ngOnInit() {
   }

   nextPage() {
      this.router.navigate(['package-receive-new/package-receive-shipper']);
   }

   goToSender() {
      this.router.navigate(['package-receive-new/package-receive-sender']);
   }

}
